import { CommonModule } from "@angular/common";
import { Component, inject, input, OnInit, output, ViewEncapsulation } from "@angular/core";
import { Router, RouterLink, RouterLinkActive } from "@angular/router";
import { SVGIconModule } from "@progress/kendo-angular-icons";
import { DrawerItem, LayoutModule } from "@progress/kendo-angular-layout";
import { PermissionScope } from "../../enums/permission-scope.enum";
import { IconComponent, IconName } from "../icon";

export interface ToggleMenuType {
  title: string,
  url: string,
  items?: Array<DrawerItem & { url: string, icon: IconName, isEnable?: boolean, requiredScopes?: PermissionScope[] }>,
}

@Component({
    selector: 'cs-toggle-menu',
    imports: [
        IconComponent,
        SVGIconModule,
        RouterLink,
        LayoutModule,
        CommonModule,
        RouterLinkActive
    ],
    templateUrl: './toggle-menu.component.html',
    styleUrls: ['./toggle-menu.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ToggleMenuComponent implements OnInit {
  public menuProps = input<ToggleMenuType>();
  public router = inject(Router);
  public closeDrawerEvent = output();

  public menuConfig = {
    isExpanded: false,
    isActivated: false,
  }

  goToUrl(): void {
    const currentUrl = this.menuProps()?.url;
    if (currentUrl) {
      this.router.navigateByUrl(currentUrl);
    }
  }

  closeDrawer(): void {
    this.closeDrawerEvent.emit();
  }

  ngOnInit() {
    const activeRoute = this.router.routerState.snapshot.url;
    const currentUrl = this.menuProps()?.url;
    if (currentUrl && activeRoute.includes(currentUrl)) {
      this.menuConfig.isActivated = true;
      this.menuConfig.isExpanded = true;
    }
  }
}